import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, UrlSegment } from '@angular/router';
import { BaseComponent } from '../shared';
import { RouteService } from 'app/shared/services';
import { OutstandingBalanceAlertService } from 'app/shared/services/outstanding-balance-alert/outstanding-balance-alert.service';

@Component({
    selector: 'pages',
    template: `
    <app-shell [hideTopbar]="isHide">
      <div [ngClass]="{'al-container': !!routerService.queueMonitoring,'al-content': !routerService.queueMonitoring}" class="pt-2">
        <router-outlet *ngIf="isLoadData"></router-outlet>
      </div>
    </app-shell>
    <app-confirm-modal #appConfirmModal></app-confirm-modal>
    <app-confirm-password #appConfirmPassword></app-confirm-password>
    <outstanding-balance-breakdown #obaBreakdown></outstanding-balance-breakdown>
    `
})
export class Pages extends BaseComponent {

    get isLoadData() { return this.authService.isLoadData }


    @ViewChild('appConfirmModal') set appConfirmModal(value) {
        this.confirmModalService.appConfirmModal = value;
    };

    @ViewChild('appConfirmPassword') set appConfirmPassword(value) {
        this.confirmPasswordService.appConfirmPassword = value;
    };

    @ViewChild('obaBreakdown') set obaBreakdown(value) {
        this.outstandingBalanceAlertService.breakdownModal = value;
    };

    isHide: boolean = false;
    constructor(private activatedRoute: ActivatedRoute, public routerService: RouteService,
        private outstandingBalanceAlertService: OutstandingBalanceAlertService) {
        super();
    }

    checkRouteChildrenForURL(route: ActivatedRoute) {
        console.log('route: ', route);
        if (route != null) {
            if (route.firstChild != null) {
                route.firstChild.url.subscribe((values: UrlSegment[]) => {
                    if (values.filter(r => r.path == 'settlementDetail').length > 0) {
                        this.isHide = true;
                    }
                    else {
                        if (route.children.length > 0) {
                            this.checkRouteChildrenForURL(route.children[0]);
                        }
                    }
                }).unsubscribe();
            }
            else { this.isHide = false; }
        } else { this.isHide = false; }
    }
    hide() {
        this.activatedRoute.url.subscribe((values: UrlSegment[]) => {
            console.log('log1:', this.activatedRoute);
            if (values.filter(r => r.path == 'settlementDetail').length > 0) {
                this.isHide = true;
            }
            else {
                if (this.activatedRoute.children.length > 0) {
                    this.checkRouteChildrenForURL(this.activatedRoute.children[0]);
                }
            }
        });
        return this.isHide;
    }
}
